module.exports = __webpack_public_path__ + "static/Vampire_2-019026309b3e4cf374c678fdcecffbe4.jpg";